import React from 'react'
import { LAYOUT_HELP_ARTICLE_URL } from './layoutBuilderHelp'

// Small "Learn more" link to the Layout Builder help article, shared by the portal and the public planner.
export default function LayoutHelpLink ({ label = 'Learn more about layouts' }) {
  return (
    <a className='layoutBuilder-help-link' href={LAYOUT_HELP_ARTICLE_URL} target='_blank' rel='noopener noreferrer'>
      <i className='pi pi-question-circle' aria-hidden='true' /> {label}
    </a>
  )
}
